"use client";

import Header from "./Header";
import Footer from "./Footer";
import { useFooterVisibility } from "@/context/FooterVisibilityProvider";
import { usePathname } from "@/i18n/navigation";

export default function LayoutContent({
  children,
  showLocaleSwitcher = true,
}: {
  children: React.ReactNode;
  showLocaleSwitcher?: boolean;
}) {
  const { hideFooter, hideHeader } = useFooterVisibility();
  const pathname = usePathname();
  const isMaintenanceRoute = pathname.endsWith("/maintenance");

  return (
    <div className="flex min-h-screen flex-col bg-background text-foreground overflow-x-hidden">
      {!hideHeader && !isMaintenanceRoute && <Header showLocaleSwitcher={showLocaleSwitcher} />}
      <main className="flex flex-col flex-1">
        {children}
      </main>
      {!hideFooter && !isMaintenanceRoute && <Footer />}
      <div className="h-[env(safe-area-inset-bottom)] bg-background"></div>
    </div>
  );
}
